export default "__VITE_ASSET__CebVPboN__"